import { getTimelineEventList } from './timelineEvents';
import { parseLocalDateString, getTimeFromDateOnly } from './localDate';

/**
 * Milliseconds since epoch for ordering cases by "last activity" recency (desc = newest first).
 * Prefers denormalized last_activity_date, then max timeline event date, then final_decision_date.
 */
export function lastActivitySortKey(app) {
  if (!app) return Number.NEGATIVE_INFINITY;
  if (app.last_activity_date) {
    const t = getTimeFromDateOnly(app.last_activity_date);
    if (!Number.isNaN(t)) return t;
  }
  let last = null;
  const events = getTimelineEventList(app.timeline);
  if (Array.isArray(events)) {
    for (const s of events) {
      if (!s?.date) continue;
      const d = parseLocalDateString(s.date);
      if (d && !Number.isNaN(d.getTime()) && (!last || d > last)) last = d;
    }
  }
  if (last) return last.getTime();
  if (app.final_decision_date) {
    const t = getTimeFromDateOnly(app.final_decision_date);
    if (!Number.isNaN(t)) return t;
  }
  return Number.NEGATIVE_INFINITY;
}
